import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { AccountInfoModalAccountFragmentDoc } from './AccountInfoModalAccount.generated'
import * as Types from './purchasePlus_graphql'

export const AccountInfoButtonAccountFragmentDoc = gql`
  fragment AccountInfoButtonAccount on Account {
    ...AccountInfoModalAccount
  }
  ${AccountInfoModalAccountFragmentDoc}
` as unknown as DocumentNode<Types.AccountInfoButtonAccountFragment, unknown>
